import { cn } from "@/utils/cn";
import type { LevelId, PositionId, Selection } from "./model";
import { LEVELS, POSITIONS } from "./model";

export function PositionStep({
  selection,
  onPickPosition,
  onPickLevel,
}: {
  selection: Selection;
  onPickPosition: (id: PositionId) => void;
  onPickLevel: (id: LevelId) => void;
}) {
  return (
    <div className="trial-fade-in">
      <h3 className="mb-1 text-[17px] font-bold tracking-tight text-[var(--trial-foreground)]">어떤 포지션을 찾으세요?</h3>
      <p className="mb-4 text-[13px] text-[var(--trial-muted)]">직군과 연차를 고르면 그에 맞는 역량을 추천해드려요.</p>

      <div className="grid grid-cols-2 gap-2">
        {POSITIONS.map((position) => {
          const active = selection.positionId === position.id;
          return (
            <button
              key={position.id}
              type="button"
              onClick={() => onPickPosition(position.id)}
              className={cn(
                "rounded-2xl p-3 text-left transition-all hover:-translate-y-0.5",
                active ? "ring-2 ring-[var(--trial-brand)] bg-[var(--trial-brand-bg)]" : "trial-glass-subtle hover:bg-white/60",
              )}
            >
              <div
                className={cn(
                  "text-[14px] font-semibold leading-tight",
                  active ? "text-[var(--trial-brand)]" : "text-[var(--trial-foreground)]",
                )}
              >
                {position.chipLabel}
              </div>
              <div className="mt-0.5 text-[11.5px] leading-snug text-[var(--trial-muted)]">{position.blurb}</div>
            </button>
          );
        })}
      </div>

      <div className="mt-5">
        <div className="mb-2 text-[12.5px] font-semibold uppercase tracking-wide text-[var(--trial-muted)]">연차</div>
        <div className="flex gap-2">
          {LEVELS.map((level) => {
            const active = selection.level === level.id;
            return (
              <button
                key={level.id}
                type="button"
                onClick={() => onPickLevel(level.id)}
                className={cn(
                  "flex-1 rounded-xl py-2.5 transition-all",
                  active
                    ? "trial-brand-gradient text-white shadow-[0_4px_14px_-3px_rgba(79,109,245,0.5)]"
                    : "trial-glass-subtle text-[var(--trial-muted-strong)] hover:text-[var(--trial-foreground)]",
                )}
              >
                <div className="text-[13.5px] font-semibold leading-none">{level.label}</div>
                <div className={cn("mt-1 text-[11px]", active ? "text-white/80" : "text-[var(--trial-muted)]")}>
                  {level.yearsText}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
